// extracted by mini-css-extract-plugin
module.exports = {"custom-button":"customButton_custom-button__26XmL","disabled":"customButton_disabled__1ZHWy"};